export const ALLOW_SIGNATURE_FILE_TYPES = ['image/png']
